import Vue from "vue";

const useMatchMedia = (mediaQuery) => {
	const match = window.matchMedia(mediaQuery);
	const ref = Vue.observable({ value: match.matches });
	if (match.addEventListener) {
		match.addEventListener("change", () => (ref.value = match.matches));
	} else {
		match.addListener(() => (ref.value = match.matches));
	}
	return ref;
};

const isLt900 = useMatchMedia("not all and (min-width: 900px)");

export const detectingMobileMixin = {
	computed: {
		$_isMobile() {
			return isLt900.value;
		},
	},
};
